import { TextInput, required } from "react-admin";
import { Grid } from "@mui/material";

const SaveForm = () => {
  return (
    <Grid
      container
      spacing={2}
    >
      <Grid
        item
        md={4}
        xs={12}
      >
        <TextInput
          label="Име на фирмата"
          source="companyName"
        />
      </Grid>
      <Grid
        item
        md={5}
        xs={12}
      >
        <TextInput
          label="Лице за контакт"
          source="personName"
          validate={required()}
        />
      </Grid>
      <Grid
        item
        md={3}
        xs={12}
      >
        <TextInput
          label="Телефон за контакт"
          source="phoneNumber"
          validate={required()}
        />
      </Grid>
      <Grid
        item
        md={3}
        xs={12}
      >
        <TextInput
          label="Имейл за контакт"
          source="email"
        />
      </Grid>
    </Grid>
  );
};
export default SaveForm;
